import { create } from "zustand";
import { produce } from "immer";

export interface ICodeStepStore {
	error: string | null;
	clearError: () => void;
	code: string | null;
	setCode: (newCode: string | null) => void;
}

export const codeStepStore = create<ICodeStepStore>((set) => ({
	responseData: null,
	code: null,
	setCode: (newCode: string | null) => {
		set(
			produce((store: ICodeStepStore) => {
				if (!newCode) {
					store.code = null;
					store.clearError();

					return;
				}
				store.error = /^[0-9]{6}$/.test(newCode) ? null : "Invalid code";
				store.code = newCode;
			})
		);
	},
	error: null,
	clearError: () => {
		set(
			produce((store: ICodeStepStore) => {
				store.error = null;
			})
		);
	}
}));
